const CONTENT = 'Content';
const TECH = 'Technical';
const OTHER = 'Other';

export const ISSUE_TYPES = { CONTENT, TECH, OTHER };
